import { useEffect, useRef } from 'react';

import styles from './Checkbox.module.css';

interface CheckboxProps {
  checked: boolean;
  /** Some but not all — draws the dash instead of a tick. */
  indeterminate?: boolean;
  onChange: () => void;
  /** Needed wherever the box has no visible label of its own. */
  label?: string;
}

/**
 * The app's checkbox: a visually-hidden input driving a token-styled box, so a
 * checked box wears the same soft-accent as every other selected thing here
 * rather than the browser's saturated `accent-color` fill.
 */
export function Checkbox({ checked, indeterminate = false, onChange, label }: CheckboxProps) {
  const ref = useRef<HTMLInputElement>(null);

  // `indeterminate` is a DOM property with no JSX attribute; set it directly.
  useEffect(() => {
    if (ref.current) ref.current.indeterminate = indeterminate;
  }, [indeterminate]);

  return (
    <span className={styles.checkbox}>
      <input
        ref={ref}
        type="checkbox"
        checked={checked}
        aria-label={label}
        onChange={() => onChange()}
      />
      <span className={styles.box} aria-hidden="true" />
    </span>
  );
}
